
/*
  This component will display steps in configurator
 */

import React, {useEffect, useState} from 'react'
import Select from '../../common_elements/Select'
import Radio from '../../common_elements/Radio'
import {useSelector, useDispatch} from "react-redux";
import {patternSideSelectionChanged} from "../../../store/product/patternSelectionsSlice";
import ExceptionMessage from "../../common_elements/ExceptionMessage";

const PatternAttribute = (props) => {

    const dispatch = useDispatch();
    const product = useSelector(state => state.productDataReducer)
    const disabledFields = useSelector(state => state.disabledFieldsReducer.sideDisabledFields);
    const [showException, setShowException] = useState(false);
    const [messages, setMessages] = useState([]);
    const [exceptionLeft, setExceptionLeft] = useState(0);

    // this generates unique key, used for radiobutton group
    const generateKey = () => {
        return `configurator_attribute_${ new Date().getTime() }`;
    }

    const handleChange = (value) => {
            dispatch(patternSideSelectionChanged(props.attribute, value, props.patternSideKey ))
    }

    const handleDisabledClick = (e) => {
        setShowException(true);
        const mouseX = e.pageX;
        // setup the exception message as well
        const disabledSelections = getMatchingDisabledSelections();
        const message = disabledSelections.messages;
        setExceptionLeft(mouseX);
        setMessages(message);
    }

    const hideExceptionMessage = () => {
        setMessages([]);
        setShowException(false);
    }

    const exceptionMessage = () => {
        if(!showException || messages.length == 0 ) {
            return;
        }

        return <ExceptionMessage message={messages} posLeft={exceptionLeft}/>
    }

    const getMatchingDisabledSelections = () => {
        if(disabledFields == null ){
            return;
        }
        const disabledSide = disabledFields.find(side => Object.keys(side)[0] == props.patternSideKey)

        if(!disabledSide){
            return;
        }

        const disabledSideSelections = disabledSide[props.patternSideKey];
        const matchingField = disabledSideSelections.find(obj => obj.field == props.attribute.name);
        return matchingField;
    }

    const getDisabledSelections = () => {
        const matchingField = getMatchingDisabledSelections();
        return matchingField ? matchingField.disabledSelections : [];
    };

    const setCornerSelection = () => {
        if(props.patternSideKey != 'CORNER' || props.currentValue){
            return;
        }

        dispatch(patternSideSelectionChanged(props.attribute, props.attribute.values, props.patternSideKey ))
    }

    useEffect(() => {
        setCornerSelection();
    }, [])

    // checks if this pattern side is a matching side
    // matching sides will be named A2, A3, etc, A1 is not matching
    const isMatchingSide = () => {
        const side = props.patternSideKey;
        // note this will not work with A11, A12 etc
        const regex = `((?![A-Za-z][1])[A-Za-z]\\d)`;
        return side.match(regex) != null;
    }

    const getPrimaryAttribute = () => {
        // exit if no selections
        if(!product.side_attribute_selections){
            return;
        }
        // create the primary side key, the first letter of this sidekey with 1 appended
        const sideKey =  props.patternSideKey[0] + '1';
        const side = product.side_attribute_selections[sideKey];
        if(!side){
            return;
        }
        // return the primary attribute once found
        const attr = side.product_attributes.find((att) => att.label == props.attribute.label);
        return attr
    }

    const getPrimaryValue = () => {
        const attr = getPrimaryAttribute();
        // extract the value from the primary attribute or return nothing
        return attr ? attr.selection : "";
    }
    
    // this piece of code determine wether we render a select box for attribute or a radio button
    const radioOrSelect = () => {
        let values = props.attribute.values;
        if (values.length > 5) {
            // return <label><Select attributes={props.attribute} patternSideKey={props.patternSideKey} product={props.product} propType={'PATTERN-ATTRIBUTE'} disabled={isMatchingSide()}  currentValue={primaryValue ? primaryValue : props.currentValue} fieldId={props.index} exceptions={getMatchingExceptions()} hasEmptyField={props.currentValue == null} onClick={(e) => handleDisabledClick()} onChange={() => hideExceptionMessage()}/></label>
            return <label onBlur={() => hideExceptionMessage()}><Select attributes={props.attribute} patternSideKey={props.patternSideKey} product={props.product} propType={'PATTERN-ATTRIBUTE'}  currentValue={props.currentValue} fieldId={props.index}  hasEmptyField={props.currentValue == null} disabledSelections={getDisabledSelections()} handleAttribute={handleChange} onClick={(e) => handleDisabledClick(e)} onChange={() => hideExceptionMessage()} matchingSide={isMatchingSide()}/></label>
        } else {
            return  <label><Radio patternSideKey={props.patternSideKey} attributes={props.attribute} product={props.product} propType={'PATTERN-ATTRIBUTE'} currentValue={props.currentValue} group={generateKey}  checkType={'radio'} fieldId={props.index} handleAttribute={handleChange} onClick={(e) => handleDisabledClick(e)} onChange={() => hideExceptionMessage()} disabledSelections={getDisabledSelections()} matchingSide={isMatchingSide()}/></label>
        }
    }

    return (
        <div className="side-step">
            <div className="row flex-row">
                <div className="title small-12 medium-2 columns">
                    <h3>Length</h3>
                </div>
                <div className="selection small-12 medium-10 columns">
                    <fieldset>
                        { radioOrSelect() }
                    </fieldset>
                </div>
            </div>
            { exceptionMessage() }
        </div>
    )

}

export default PatternAttribute;
